<template>
  <v-card class="my-2 mx-1 || my-md-5 | || pb-3 justify-center clickable hoverable" :max-width="maxWidth">
    <v-img contain :src="logo" class="mx-1 mt-2 || ma-md-3 mb-md-0" :height="height"/>
    <div class="text-caption px-1 || pa-md-4 pb-md-0 | text-md-body-2 || justify-center text-center"
         :class="textCssClass">
      {{ title }}
    </div>
  </v-card>
</template>
<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

const darkLogo = require('../assets/images/dynameat-logo-long-dark.png');

@Component
export default class DynameatCard extends Vue {
  @Prop(String) title;

  @Prop(String) logoUrl;

  get logo() {
    return this.logoUrl || darkLogo;
  }

  get maxWidth() {
    return this.$vuetify.breakpoint.mdAndUp ? 175 : 80;
  }

  get height() {
    return this.$vuetify.breakpoint.mdAndUp ? 75 : 50;
  }

  get textCssClass() {
    return {
      'grey-text': this.$vuetify.breakpoint.mdAndUp
    };
  }
}
</script>

<style>
.hoverable {
  cursor: pointer;
}

.grey-text {
  color: #6e6e6e;
}
</style>
